import OneAppointmets from './One';

export default function SectionAppointmets({ data, noName, patient }) {
    function SectionHeader ({text, count}) {
        return (
            <div className={`appointment-section-info`}>
                <div/>
                <p>{`${text} (${count} نوبت)`}</p>
                <div/>
            </div>
        )
    }
    return (
        <>
            {
                data.filter(i => i.lastStatus === 6).length !== 0 &&
                <>
                    <SectionHeader text={'نوبت های هماهنگ شده'} count={data.filter(i => i.lastStatus === 6).length}/>
                    {
                        data.filter(i => i.lastStatus === 6)
                        .sort((a,b) => ((+a.time.replace('/','')) - (+b.time.replace('/',''))))
                        .map(item => {
                            return(
                                <OneAppointmets
                                    key={`appointment_ws_${Date.now()}_${item.id}`}
                                    data={item}
                                    noName={noName}
                                    patient={patient}
                                />
                            )
                        })
                    }
                </>
            }
            {
                data.filter(i => (i.lastStatus !== 4 && i.lastStatus !== 5 && i.lastStatus !== 6)).length !== 0 &&
                <>
                    <SectionHeader text={'نوبت های تثبیت نشده'} count={data.filter(i => (i.lastStatus !== 4 && i.lastStatus !== 5 && i.lastStatus !== 6)).length}/>
                    {
                        data.filter(i => (i.lastStatus !== 4 && i.lastStatus !== 5 && i.lastStatus !== 6))
                        .sort((a,b) => ((a.lastStatus - b.lastStatus)))
                        .map(item => {
                            return(
                                <OneAppointmets
                                    key={`appointment_ws_${Date.now()}_${item.id}`}
                                    data={item}
                                    noName={noName}
                                    patient={patient}
                                />
                            )
                        })
                    }
                </>
            }
            {
                data.filter(i => i.lastStatus === 4).length !== 0 &&
                <>
                    <SectionHeader text={'نوبت های انجام شده'} count={data.filter(i => i.lastStatus === 4).length}/>
                    {
                        data.filter(i => i.lastStatus === 4).sort((a,b) => ((+a.time.replace('/','')) - (+b.time.replace('/',''))))
                        .map(item => {
                            return(
                                <OneAppointmets
                                    key={`appointment_ws_${Date.now()}_${item.id}`}
                                    data={item}
                                    noName={noName}
                                    patient={patient}
                                />
                            )
                        })
                    }
                </>
            }
            {
                data.filter(i => i.lastStatus === 5).length !== 0 &&
                <>
                    <SectionHeader text={'نوبت های کنسل شده کامل'} count={data.filter(i => i.lastStatus === 5).length}/>
                    {
                        data.filter(i => i.lastStatus === 5).map(item => {
                            return(
                                <OneAppointmets
                                    key={`appointment_ws_${Date.now()}_${item.id}`}
                                    data={item}
                                    noName={noName}
                                    patient={patient}
                                />
                            )
                        })
                    }
                </>
            }
        </>
    );
}